import Styles from './Actionbutton.scss';

import Template from './Actionbutton.hbs';
import ShapeList from 'util/ShapeLoader'

export default class ActionButton extends BaseView {

    get events() {
        return {
            click: 'onClickActionButton'
        }
    }

    initialize() {

        _.bindAll(this,
            'show',
            'hide',
            'setLabel',
            'onClickActionButton',
        );

        // Create a default callback for click
        this.clickCallback = function() {};

        // Build element with template vars
        this.setElement(Template({
            Styles
        }));

        // Hide by default
        this.hide();
    }

    /**
     * show
     *
     * This function will handle the showing of the actionbutton.
     * It wil set (or clear) its label and set the callback
     *
     * @param  {Function} callback  This is the function which will be executed on click
     * @param  {string} label       This is the label, when empty it wil not show label
     */
    show(callback, label) {

        this.setLabel(label);

        this.clickCallback = callback;

        this.$el.show();

        this.isShowing = true;
    }

    /**
     * onClickActionButton
     *
     * This function will be called on a click on the actionbutton.
     * It will execute the callback given within this.
     @param {object} e event Object
     */
    onClickActionButton(e) {

        this.undelegateEvents()

        if (e) {
            e.stopPropagation()
        }

        // Execute clickCallback if function
        if (this.clickCallback !== undefined && typeof this.clickCallback === 'function') {
            this.clickCallback()
        }

        // If the callback is not persistant, hide the action button
        if (!this.persistantCallback) {
            this.hide()
        }

        setTimeout(() => {
            this.delegateEvents()
        }, 1000)
    }

    /**
     * setLoading
     *
     * This function will transform the button into a loading state button. It will
     * use the Loading... label when there is no label given. keepStyle is true.
     *
     * @param  {string} label Optional label
     */
    setLoading(label) {

        // Switch icon to loading
        this.switchIcon('loading');

        // Show the new actionbutton
        this.show(null, label || window.i18n.gettext('Loading...'));
    }

    /**
     * hide
     *
     * Hide the actionbutton
     *
     */
    hide() {
        this.$el.hide();
        this.isShowing = false;
    }

    /**
     * switchIcon
     *
     * Function to switch out the icon of the icon button. It will hide
     * all icons by default and then unhide the chosen one.
     *
     * @param  {string}     type The type of icon
     * @returns {Boolean}   Return false on abort
     */
    switchIcon(type) {

        // When the to be switched to icon is the same as the active stop execution
        // to prevent unneccesary transitions
        if (type === this.iconType) {
            return;
        }

        this.$('.js-actionbutton--icon').html(ShapeList[type]);

        // Store the type in a global variable
        this.iconType = type;
    }

    /**
     * setLabel
     *
     * This function will show or hide the label based on the argument given.
     * It will also update te text of the label element
     *
     * @param  {string} labelText The label text
     */
    setLabel(labelText) {
        if (!labelText) {
            this.$('.js-actionbutton-label__outer').hide();
            this.$('.js-actionbutton-label').html('');
        } else {
            this.$('.js-actionbutton-label__outer').show();
            this.$('.js-actionbutton-label').html(labelText);
        }
    }
}
